/**
 * Web Push subscription helpers (client-side).
 * Uses the existing `/sw.js` service worker registered in index.js.
 */
import api from './api';

const urlBase64ToUint8Array = (b64) => {
  const padding = '='.repeat((4 - (b64.length % 4)) % 4);
  const base64 = (b64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
};

export const pushSupported = () =>
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  'Notification' in window;

export const currentSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
};

export const subscribePush = async () => {
  if (!pushSupported()) throw new Error('Push non supporté par ce navigateur');
  // Trigger permission prompt
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Permission refusée');

  const { publicKey } = await api.get('/push/vapid-public-key').then((r) => r.data);
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }
  await api.post('/push/subscribe', sub.toJSON());
  return sub;
};

export const unsubscribePush = async () => {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  try {
    await api.post('/push/unsubscribe', { endpoint: sub.endpoint });
  } catch (_e) { /* ignore */ }
  await sub.unsubscribe();
};
